// extracted by mini-css-extract-plugin
module.exports = {"direttissimeCardContainer":"DirettissimeCarousel_direttissimeCardContainer__ZPWzy","paddingLeft":"DirettissimeCarousel_paddingLeft__YSTVw"};